import { pdfjs } from "react-pdf";

// Keep the worker version aligned with react-pdf and let Webpack emit it as a
// same-origin asset. This avoids a runtime dependency on unpkg.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();
